// src/multiselect/src/components/react-select-components/multi-value-container.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var MultiValueContainer = (props) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: "m-0.5 flex rounded-[3.125rem] bg-surface-strong p-1 pl-2 text-sm font-normal leading-5 text-surface-dark",
      "data-testid": "multivalue-container",
      children: /* @__PURE__ */ jsx(components.MultiValueContainer, { ...props })
    }
  );
};

export {
  MultiValueContainer
};
